/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-sidenav-container[_ngcontent-%COMP%]{height:100%}section[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}mat-card[_ngcontent-%COMP%]{margin:20px;width:80%}@media (min-width:600px){mat-card[_ngcontent-%COMP%]{width:500px}}form[_ngcontent-%COMP%]{padding-top:10px}.full-width[_ngcontent-%COMP%]{width:80%}.other-actions[_ngcontent-%COMP%]{text-align:right}.message[_ngcontent-%COMP%]{padding-top:20px}"];
export { styles as styles };
